<template>
  <div>
     <el-card>
      <search-form ref="searchForm" :topVisible="true" :tabData="tabData" labelWidth="120px" :searchFormData="searchFormData" @search="search" @tabChange="tabChange">
         <template #topBtn>
          <el-button type="primary" size="small" @click="handleExport">{{$t('button.orderExport')}}</el-button>
        </template>
      </search-form>
      <create-table :autoWidth="true" :operateVisible="operateVisible" ref="createTable" :loading="loading" :btnType="[]" :total_count="pageData.total_count ? pageData.total_count : 0" :current_page.sync="pageData.page" :papeSize.sync="pageData.per_page" @selectionChange="selectionChange" :topButtonVisible="true" :tableData="tableData" :tableDataItem="tableDataItem" :pageVisible="true" :pageData="pageData" @forwardToPage="forwardToPage" :checkBoxVisible="dropDataItem.length > 0" @handleSort="handleSort">
        <template #topButton>
          <span v-if="dropDataItem.length > 0" class="marginRight20 spanminWith">{{`${$t('text.selected')}：${selectionData.length}`}}</span>
          <!-- <dropListCollect v-if="dropDataItem.length > 0" :dropDisabled="selectionData.length < 1" :dropDataItem="dropDataItem" class="marginRight20" @chooseDropItem="chooseDropItem"></dropListCollect> -->
          <allButton :buttonDisabled="selectionData.length < 1" :buttonDataItem="dropDataItem" class="marginRight20" @chooseDropItem="chooseDropItem"></allButton>
        </template>
        <template #rightBtn="scope">
          <el-button class="margintop10" v-for="(item, index) in scope.row.member_actions.default_actions" :key="'default_actions' + index" :type="item.type && item.type === 'warn' ? 'danger' : 'primary'" size="mini" @click="handleClick(item, scope.row)">{{item.name}}</el-button>
          <el-button class="margintop10" v-for="(item, index) in scope.row.member_actions.custom_actions" :key="'custom_actions' + index" :type="item.type && item.type === 'warn' ? 'danger' : 'primary'" size="mini" @click="handleCusClick(item)">{{item.name}}</el-button>
        </template>
      </create-table>
    </el-card>
    <router-view/>
    <dialogEffect v-if="dialogVisible" :dialogVisible.sync="dialogVisible" :data="dialogData" @doNextConfirm="doNextConfirm"></dialogEffect>
  </div>
</template>

<script>
import { getBreakDownOrderSetup, getBreakDownOrderQueryList, gettBreakDownOrderExport } from '@/services/order'
// import _ from 'lodash'
// import loading from '@/utils/loading.json'
import jsonData from './jsonData.js'
import allButton from '@/components/allButton'
import searchForm from '@/components/searchForm'
import createTable from '@/components/createTable'
import dialogEffect from '@/components/dialogEffect'
import { mixin } from '@/mixins/mixin'
export default {
  name: 'managerUserOrders',
  mixins: [mixin],
  components: {
    searchForm,
    createTable,
    allButton,
    dialogEffect
  },
  data () {
    return {
      // searchFormData: [],
      // dropDataItem: [],
      // selectionData: [],
      tableDataItem: jsonData.tableDataItem
      // tabData: [],
      // tableData: [],
      // loading: false,
      // pageData: {
      //   page: 1,
      //   per_page: 50
      // },
      // searchData: undefined,
      // operateVisible: true
    }
  },
  watch: {
    // 'pageData.page': {
    //   handler () {
    //     this.search()
    //   }
    // },
    // 'pageData.per_page': {
    //   handler () {
    //     this.search()
    //   }
    // },
    $route (to, from) {
      // console.log(from)
      if (from.name === 'managerBreakDownOrdersView') {
        this.$nextTick(() => {
          this.search()
          this.$refs.createTable.$refs.table.doLayout()
        })
      }
    }
  },
  created () {
    this.queryData(getBreakDownOrderSetup)
  },
  activated () {
    if (this.isActive) this.queryData(getBreakDownOrderSetup)
    this.isActive = true
  },
  methods: {
    // 导出数据接口
    handleExport () {
      this.$refs.searchForm.commonOperate(gettBreakDownOrderExport, (data) => {
        this.$router.push({
          name: 'breakDownDownloadCenter',
          params: { data }
        })
      }, this)
    },
    // async queryData () {
    //   const res = await getOrderSetup()
    //   if (res.data) {
    //     this.tabData = res.data.setup.scopes
    //     this.dropDataItem = res.data.setup.batch_actions
    //     this.deepDropItem = _.cloneDeep(this.dropDataItem)
    //     this.member_actions = res.data.setup.member_actions
    //     res.data.setup.sort_options.forEach(sort => {
    //       const index = this.tableDataItem.findIndex(item => item.prop === sort.name)
    //       Object.assign(this.tableDataItem[index], {
    //         sortable: false,
    //         values: sort.values
    //       })
    //     })
    //     if (res.data.setup.column_titles.length > 0) {
    //       this.tableDataItem.forEach((col, colNum) => {
    //         col.label = res.data.setup.column_titles[colNum]
    //       })
    //       const name = res.data.setup.column_titles[res.data.setup.column_titles.length - 1]
    //       if (name !== '操作' && name !== 'Actions') this.operateVisible = false
    //     }
    //     this.searchFormData = res.data.setup.filters.map(item => {
    //       return Object.assign(item, { span: 4 })
    //     })
    //   }
    //   this.$nextTick(() => {
    //     this.$refs.searchForm && this.$refs.searchForm.onSubmit()
    //   })
    // },
    // // 排序
    // handleSort (val) {
    //   this.$refs.searchForm.onSubmit(val)
    // },
    // // 数据的选择
    // selectionChange (val) {
    //   this.selectionData = val
    // },
    // handleCusClick (data) {
    //   Utils.custOperate(data, this)
    // },
    // 点击操作按钮
    async forwardToPage (data, name) {
      if (name === 'user_order') {
        this.$router.push({
          name: 'ordersManagerUserOrdersDetail',
          params: {
            id: data.id
          }
        })
      }
      if (name === 'shop') {
        this.$router.push({
          name: 'shopsManagerDetail',
          params: {
            id: data.id
          }
        })
      }
      if (name === 'shop_item') {
        this.$router.push({
          name: 'goodsManagerProductDetail',
          params: {
            id: data.id
          }
        })
      }
      if (name === 'shop_item_stock') {
        this.$router.push({
          name: 'goodsManagerVariationsDetail',
          params: {
            id: data.id
          }
        })
      }
      if (name === 'supplier') {
        this.$router.push({
          name: 'suppliersDetail',
          params: {
            id: data.id
          }
        })
      }
    },
    // async handleForwards (type, data) {
    //   this.$store.state.app.loading = this.$loading(loading)
    //   let obj = {}
    //   if (type?.action === 'view') {
    //     const res = await getBreakDownOrderDetails(data.id.value)
    //     if (res.status === 200) {
    //       obj = res.data.delivery_order
    //     }
    //   }
    //   this.$store.state.app.loading.close()
    //   sessionStorage.setItem('dataOperate', JSON.stringify({ id: data && data.id ? data.id : undefined, type: type.action, obj, data }))
    //   this.$router.push({
    //     name: 'managerBreakDownOrdersView'
    //   })
    // },
    // // 操作已选项
    // chooseDropItem (val) {
    //   const data = this.dropDataItem.filter(item => item.name === val)
    //   console.log(data)
    //   const ids = []
    //   this.selectionData.forEach(item => {
    //     ids.push(item.id.value)
    //   })
    //   Utils.custOperate(data[0], this, { ids })
    // },
    // // tab切换
    // tabChange (val) {
    //   const index = this.dropDataItem.findIndex(item => item.value === this.tabData[val].value)
    //   const data = _.cloneDeep(this.deepDropItem)
    //   if (index !== -1) {
    //     data.splice(index, 1)
    //     this.dropDataItem = data
    //   } else {
    //     this.dropDataItem = data
    //   }
    // },
    // 查询
    search (data) {
      if (data) this.searchData = data
      const { page, per_page } = this.pageData
      Object.assign(this.searchData, { page, per_page })
      this.loading = true
      getBreakDownOrderQueryList(this.searchData).then(res => {
        if (res.data) {
          this.tableData = res.data.objects
          this.tabData = res.data.scopes
          Object.assign(this.pageData, res.data.pagination)
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style>

</style>
